import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AutobookingForm } from 'shared/components/AutobookingForm';
import { FormattedMessage } from 'react-intl';
// import { phoneNormalize } from 'shared/modules';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';
import StoAwards from 'shared/components/StoAwards/StoAwards';
import cx from 'classnames';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import withPixelRatio from 'shared/hocs/withPixelRatio';
// import DealerServices from 'shared/components/DealerServices/DealerServices';
import API from 'shared/constants/api';
import Link from 'shared/components/Link';
import { withTranslate } from 'shared/hocs/withTranslate';
import FirmLocation from 'shared/components/FirmLocation/FirmLocation';
import DealerSocials from 'shared/components/DealerSocials/DealerSocials';
import IconTradeIn from 'shared/components/DealerItem/Icons/TradeIn';
import IconTestDrive from 'shared/components/DealerItem/Icons/TestDrive';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import DealerServiceForm from 'shared/components/DealerServiceForm/DealerServiceForm';
import ThanksBlock from 'shared/components/DealerServiceForm/ThanksBlock';
import { ContactPhoneButton, TagButton } from 'shared/components/UI';
import { IsVerifiedElement, IsGuaranteedElement } from 'shared/components/Elements';
import { fireRTBEvent } from 'shared/helpers/rtbHouse';

import s from './DealerInfo.css';

class DealerInfo extends React.Component {
  static propTypes = {
    setRatioImage: PropTypes.func.isRequired,
    //
    title: PropTypes.string.isRequired,
    promo_video: PropTypes.string,
    logo: PropTypes.string.isRequired,
    cover: PropTypes.string,
    id: PropTypes.number.isRequired,
    website: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    events: PropTypes.shape().isRequired,
    makes: PropTypes.arrayOf(PropTypes.shape()),
    messengers: PropTypes.arrayOf(PropTypes.shape()),
    awards: PropTypes.arrayOf(PropTypes.shape()),
    schedule: PropTypes.string.isRequired,
    phones: PropTypes.arrayOf(
      PropTypes.shape({
        number: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
      }).isRequired,
    ),
    is_official: PropTypes.bool,
    trade_in: PropTypes.bool,
    insurance: PropTypes.bool,
    test_drive: PropTypes.bool,
    credit: PropTypes.bool,
    accessories: PropTypes.bool,
    children: PropTypes.node,
    type: PropTypes.string,
    geo_location: PropTypes.shape({ lat: PropTypes.number, lon: PropTypes.number }),
    official_make: PropTypes.shape(),
    slug: PropTypes.string,
    association_guarantees: PropTypes.bool,
    is_verified: PropTypes.bool,
    setDataLayer: PropTypes.func.isRequired,
    //
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    is_official: false,
    promo_video: null,
    makes: null,
    cover: null,
    phones: [],
    messengers: [],
    children: '',
    type: 'dealer',
    trade_in: false,
    insurance: false,
    test_drive: false,
    credit: false,
    accessories: false,
    official_make: null,
    geo_location: null,
    awards: null,
    slug: '',
  };

  state = {
    isOpenMap: false,
    showDealerServiceModal: false,
    currentService: '',
    emailSent: false,
  };

  componentDidMount() {
    const { events, id } = this.props;
    events.dispatchDealerViewEvent(id);
  }

  openMap = e => {
    e.preventDefault();

    if (this.props.geo_location) {
      this.setState({ isOpenMap: true });
    }
  };

  closeMap = e => {
    e.preventDefault();
    this.setState({ isOpenMap: false });
  };

  handleShowPhoneClick = e => {
    e.preventDefault();

    const { events, id } = this.props;
    events.dispatchDealerShowPhoneEvent(id);

    const gtmEvent = EVENTS.DEALER_CARD.showNubmer;
    if (gtmEvent) this.props.setDataLayer(gtmEvent);
  };

  onGoToDiealerSite = () => {
    const gtmEvent = EVENTS.DEALER_CARD.goToSite;
    if (gtmEvent) this.props.setDataLayer(gtmEvent);
  };

  openServiceModal = (event, serviceType) => {
    this.setState({
      showDealerServiceModal: true,
      currentService: serviceType,
    });
    const eventName = { 'Trade-in': 'tradeIn', 'Тест-драйв': 'testDrive' };
    const gtmEvent = EVENTS.DEALER_CARD[eventName[serviceType]];
    if (gtmEvent) this.props.setDataLayer(gtmEvent);
  };

  closeServiceModal = () => {
    this.setState({
      showDealerServiceModal: false,
      emailSent: false,
    });
  };

  onEmailSent = serviceType => {
    this.setState({ emailSent: true });
    setTimeout(() => {
      this.closeServiceModal();
    }, 5000);

    const eventName = { 'Trade-in': 'formTradeIn', 'Тест-драйв': 'formTestDrive' };
    const gtmEvent = EVENTS.DEALER_CARD[eventName[serviceType]];
    if (gtmEvent) this.props.setDataLayer(gtmEvent);

    fireRTBEvent(eventName[serviceType], {
      ids: [this.props.slug],
    });
  };

  render() {
    const {
      title,
      logo,
      cover: backgroundUrl,
      website,
      address,
      schedule,
      phones,
      makes,
      is_official: isOfficial,
      // official_make: officialMake,
      children,
      promo_video: videoId,
      type,
      trade_in,
      test_drive,
      /*       insurance,
      credit,
      accessories, */
      //
      slug,
      setRatioImage,
      awards,
      geo_location: geoLocation,
      messengers,
      association_guarantees: associationGuarantees,
      is_verified: isVerified,
      t,
    } = this.props;

    const officialMake =
      (this.props.official_make && this.props.official_make.slug
        ? this.props.official_make
        : null) || (makes && makes.length === 1 ? makes[0] : null);

    /*     const services = {
      trade_in,
      test_drive,
      insurance,
      credit,
      accessories,
    }; */

    const tags = [
      {
        title: 'Тест-драйв',
        icon: IconTestDrive,
        available: test_drive,
      },
      {
        title: 'Trade-in',
        icon: IconTradeIn,
        available: trade_in,
      },
    ];

    const { isPhoneVisible, isOpenMap } = this.state;

/*     const locale = t('locale') === 'ru' ? '' : `${t('locale')}_`;
    const agreementLink = `/pdf/${locale}terms-of-use.pdf`; */

    return (
      <div className={s.root}>
        {videoId &&
          <iframe
            title={title}
            className={s.video}
            width="890"
            height="270"
            src={`https://www.youtube.com/embed/${videoId}?rel=0&controls=0&showinfo=0&loop=1&autoplay=1&mute=1&playlist=${videoId}`}
            frameBorder="0"
            gesture="media"
            allow="encrypted-media"
            allowFullScreen
          />}
        {!videoId &&
          backgroundUrl &&
          <img
            className={s.backgroundLogoImage}
            src={backgroundUrl && setRatioImage(backgroundUrl.replace('http:', 'https:'), 750)}
            alt=""
          />}
        <div className={s.infoForUser}>
          {website
            ? <DealerWebsiteLink dealer={this.props} ClassName={s.logoImageLink}>
                <img
                  alt={title}
                  src={logo && setRatioImage(logo.replace('http:', 'https:'), 140)}
                  className={s.logoImage}
                />
              </DealerWebsiteLink>
            : <span className={s.logoImageLink}>
                <img
                  alt={title}
                  src={logo && setRatioImage(logo.replace('http:', 'https:'), 140)}
                  className={s.logoImage}
                />
              </span>}
          <div className={s.infoForUserMain}>
            {type !== 'firm' && isVerified && <IsVerifiedElement />}
            {type !== 'firm' && associationGuarantees && <IsGuaranteedElement />}
            <h1 className={s.title}>
              {title}
            </h1>
            {awards && !!awards.length && <StoAwards awards={awards} />}
            {isOfficial &&
              type !== 'firm' &&
              <div className={s.infoItem}>
                {officialMake &&
                  officialMake.slug &&
                  <img
                    src={setRatioImage(API.LOGOS(officialMake.slug), 26)}
                    className={s.officialLogoIcon}
                    width="26"
                    alt={''}
                  />}
                <FormattedMessage id="официальный дилер" />
              </div>}

            {address &&
              <a className={cx(s.infoItem, s.mapInfoItem)} onClick={this.openMap}>
                <i className={`fa fa-map-marker ${s.infoItemIcon}`} />
                <span>
                  {address}
                </span>
              </a>}

            {schedule &&
              <pre className={s.infoItem}>
                <i className={`fa fa-clock-o ${s.infoItemIcon}`} />
                {schedule}
              </pre>}
            {type !== 'firm' &&
              <div className={s.tags}>
                {tags.map(item =>
                  <TagButton
                    key={item.title}
                    title={item.title}
                    clickHandler={this.openServiceModal}
                    Icon={item.icon}
                    disabled={!item.available}
                  />,
                )}
              </div>}
          </div>

          <div className={s.infoLinks}>
            {website &&
              type === 'firm' &&
              <DealerWebsiteLink dealer={this.props} ClassName={s.logoBtnLink}>
                <FormattedMessage id={'Сайт компании'} />
              </DealerWebsiteLink>}

            {/* TODO: check AutobookingForm component !?  */}
            <AutobookingForm className={s.logoBtnLink} advert={this.props} />

            <div className={s.infoPhones}>
              <ContactPhoneButton clickHandler={this.handleShowPhoneClick} phones={phones} />
            </div>
            {website &&
              type !== 'firm' &&
              <DealerWebsiteLink
                dealer={this.props}
                ClassName={s.logoDealerBtnLink}
                onClickHandle={this.onGoToDiealerSite}
              >
                <FormattedMessage id={'Перейти на сайт'} />
              </DealerWebsiteLink>}
            {!!messengers && !!messengers.length && <DealerSocials messengers={messengers} />}
          </div>

          {this.state.showDealerServiceModal &&
            <div>
              <ModalContainer
                modalCN={s.modal}
                onClose={this.closeServiceModal}
                isOpen={this.state.showDealerServiceModal}
              >
                <div className={s.rootModal}>
                  <div className={s.rootModalBody}>
                    {this.state.emailSent
                      ? <ThanksBlock />
                      : <React.Fragment>
                          <h3 className={s.rootModalTitle}>
                            <FormattedMessage id="Заявка на" /> {this.state.currentService}
                          </h3>
                          <DealerServiceForm
                            dealerSlug={slug}
                            service={this.state.currentService}
                            onSent={() => this.onEmailSent(this.state.currentService)}
                          />
                          <p className={`${s.modalText} ${s.rootModalPolicy}`}>
                            <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_1" />
                            <br />
                            <Link className={s.modalTextLink}>
                              <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_2" />
                            </Link>
                          </p>
                        </React.Fragment>}

                    <i
                      className={cx({
                        'fa fa-times': true,
                        [s.closeBtnIcon]: true,
                      })}
                      onClick={this.closeServiceModal}
                    />
                  </div>
                </div>
              </ModalContainer>
            </div>}
        </div>

        {children}

        {geoLocation &&
          <FirmLocation
            modalCN={s.modalWindow}
            isOpen={isOpenMap}
            onClose={this.closeMap}
            title={title}
            geoLocation={geoLocation}
            address={address}
          />}
      </div>
    );
  }
}

export default withStyles(s)(
  connect(null, { setDataLayer })(withTranslate(withStatsEvents(withPixelRatio(DealerInfo)))),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/components/DealerInfo/DealerInfo.js